import NotificationActions from '../../../actions/NotificationActions';
import RoutingActions from '../../../actions/RoutingActions';
import PopupActions from '../../../actions/PopupActions';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import UserActions from '../../../actions/UserActions';


class NewTransaction extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            confirm : false
        };

        this.newTransaction = this.newTransaction.bind(this);
    }

    newTransaction() {
        const selectedLocation = UserStore.getState().selectedLocation;
        const guest = this.props.guest;

        if(this.props.loading)
            return;

        var formData        = UserStore.getApiData();
        formData.AcctId     = guest.Guest_id;
        formData.UserId     = UserStore.getState().user.userId;

        
        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(guest)) {

            NotificationActions.error('Patient\'s MMJ License has expired.');
            return;
        }

        const minorAge = UserActions.getMinorAge(selectedLocation, this.props.guest.IsMedical)
        if (selectedLocation.BlockMinorsFromCheckInFF && UserActions.checkMinorStatus(this.props.guest, minorAge)) {

            NotificationActions.error(`Patient is under the age of ${minorAge}. You cannot proceed`);
            return;
        }

        this.props.setLoading('NewTransaction', () => {
            AjaxPromises.POST(GuestEndPoints.NEW_TRANSACTION,
                formData
            ).then(res => {
                
                if (!res.Result) {
                    this.props.setLoading(false, () => {
                        NotificationActions.addNotification({
                            type : 'error',
                            body : 'New Transaction Failed',
                        });
                    });
                } else {
                    if (res.Data && res.Data[0] && res.Data[0].ScanId === 0) {
                        this.props.setLoading(false, () => {
                            NotificationActions.error(res.Data && res.Data[0] ? res.Data[0].ScanResult : res.Message);
                        });
                    } else {
                        this.props.setLoading(false, () => {
                            RoutingActions.updateRoute('pos/'+guest.Guest_id);
                            PopupActions.close();
                        });
                    }
                }
            });
        });
    }

    render() {
        var self = this;

        return (
            <button
                className='btn-green'
                onClick={this.newTransaction} >
                { this.props.loading ? 'Loading' : 'NEW TRANSACTION' }
                
            </button>
        );
    }
}

export default NewTransaction;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/NewTransaction.react.jsx